import * as React from 'react';
import { useContext } from "react";
import { useNavigate } from 'react-router-dom';
import { AuthContext } from "../contexts/AuthContext";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { Avatar } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import ImgLogo from "../img/logo-3rr.png";

export default function TopHeader() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const { user, logout, loading } = useContext(AuthContext)!;
  const navigate = useNavigate();


  if (loading) {
    return <div>Carregando...</div>; // Exibe um indicador de carregamento
  }

  const userName = user?.user_name || "Usuário";
  const initial = userName.charAt(0);

  const handleStart = () => {
    navigate('/pedidos');
  };

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout();
    console.log("Logout realizado"); // Verifique se o logout foi chamado
    handleClose();
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
    <AppBar position="fixed" sx={{ backgroundColor: '#ffffff', color: '#000000', zIndex: (theme) => theme.zIndex.drawer + 1 }} elevation={1}>
      <Toolbar>
        {/* Logo */}
        <IconButton onClick={handleStart}>
          <img src={ImgLogo} alt="Logo RiberSolo" style={{ width: "120px" }} />
        </IconButton>

        <Box sx={{ flexGrow: 1 }} />

        <Typography
          sx={{
            marginRight: 2,
            color: '#202224',
            fontSize: { xs: 12, sm: 14 }, // Tamanho da fonte responsivo
            display: { xs: 'none', sm: 'block' }, // Oculta em telas muito pequenas
          }}
        >
          {userName}
        </Typography>

        {/* Avatar e menu de usuário */}
        <IconButton onClick={handleMenu}>
          <Avatar sx={{ bgcolor: '#BFD4D7', color: 'var(--primary-color)' }}>{initial}</Avatar>
        </IconButton>

        {/* Dropdown */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem onClick={handleLogout}>Sair</MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  </Box>
);
}